//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import IconTrangle from "../../../components/IconTriangle";
import IconFeedback from "./components/IconFeedback";
import IconRules from "./components/IconRules";
import IconAboutUs from "./components/IconAboutUs";
import IconVersions from "./components/IconVersions";
import dayjs from "dayjs";

export default {
  data() {
    return {
      menus: [
        { icon: "IconFeedback", name: "意见反馈", path: "/My/feedback" },
        { icon: "IconRules", name: "规则与条款", path: "/My/rules" },
        { icon: "IconAboutUs", name: "关于我们", path: "/My/about" },
      ],
    };
  },
  components: {
    IconTrangle,
    IconFeedback,
    IconRules,
    IconAboutUs,
    IconVersions,
  },
  computed: {
    ...mapState(["loginEffect"]),
  },
  methods: {
    ...mapActions(["updateLoginEffect"]),
    changeLoginEffect(value) {
      this.updateLoginEffect(value);
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Base/components/ListMenus/index.vue